export default "__VITE_ASSET__CP91hM1U__"